export const DOCS_URL = import.meta.env.VITE_DOCS_URL ?? 'https://docs.responsedock.com';

/** Absolute URL of a docs page, e.g. docsUrl('/docs/tutorials/mobile-app', 'part-2-find-your-way-around-home'). */
export function docsUrl(path: string, anchor?: string): string {
  return `${DOCS_URL}${path}${anchor ? `#${anchor}` : ''}`;
}

export const TUTORIALS_PATH = '/docs/tutorials';
